import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ShBaseFormComponent } from '../_core/base-form/base-form.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ShFormGroupComponent } from '../_core/form-group/form-group.component';

@Component({
    selector: 'sh-form-password',
    templateUrl: './form-password.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShFormGroupComponent, ReactiveFormsModule, NgClass, AsyncPipe]
})
export class ShFormPasswordComponent extends ShBaseFormComponent {
    @Input() autocomplete?: string;
    @Input() placeholder?: string;
}
